enum TypeArrondiRegleCalcul {
	AUCUN = 0,
	EURO = 1,
	DIZAINE = 2,
	CENTAINE = 3,
}

export default TypeArrondiRegleCalcul;
